<!-- 历史朋友圈 -->
<template>
  <div>
    <div class="head-title">历史朋友圈</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            同步员工在企业微信通过客户朋友圈发布的每条内容，展示企业员工信息以及朋友圈内容、位置、评论点赞数以及员工设置的可见范围等内容。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <div style="margin-right: 2.4rem">
            <el-button type="primary" icon="el-icon-refresh" :loading="updateLoading" @click="getRenew">同步朋友圈</el-button>
          </div>
          <div style="width: 24.0rem" @click.stop="onSelectPerson">
            <el-input v-model="person.name" placeholder="选择成员" suffix-icon="el-icon-arrow-down" @change="clearD">
            </el-input>
          </div>
          <div style="margin-left: 2.4rem">
            <el-select v-model="create_type" placeholder="请选择来源" clearable @change="getData">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div style="margin-left: 2.4rem">
            <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始时间"
              end-placeholder="结束时间" :picker-options="pickerOptions" @change="getData">
            </el-date-picker>
          </div>
            <el-input v-model="q" style="width: 22.0rem; margin: 0 2.0rem 0 2.0rem" placeholder="请输入内容搜索"              prefix-icon="el-icon-search" clearable @change="getData">
              <el-button slot="append" type="primary" @click="getData">查询</el-button>
            </el-input>

          </div>
<!--        </div>-->
        <div class="nav-r"></div>
      </nav>
      <div class="">
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark"
          style="width: 100%; margin-top: 2.0rem" border v-loading="loading">
          <el-table-column prop="user_avatar" label="头像	" style="width:10%">
            <template slot-scope="scope">
              <el-image style="width: 3.2rem; height: 3.2rem" :src="scope.row.user_avatar"
                :preview-src-list="[scope.row.user_avatar]" fit="scale-down"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="user_name" label="姓名" style="width:10%" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="content" label="内容" show-overflow-tooltip style="width:10%">
          </el-table-column>
          <el-table-column prop="media_id" label="照片/视频/链接" style="width:10%">
            <template slot-scope="scope">
              <template v-if="scope.row.link_url">
                <div class="link-container">
                  <el-image style="
                        width: 4.0rem;
                        height: 4.0rem;
                        float: left;
                        margin-right: 1.0rem;
                      " v-for="(item, index) in scope.row.media_id" :src="`${item}`"
                    :preview-src-list="scope.row.media_id" :key="index" fit="cover"></el-image>
                  <a :href="scope.row.link_url" class="el-link el-link--primary is-underline" :title="scope.row.link_url"
                    target="_blank">{{ scope.row.link_title }}</a>
                </div>
              </template>
              <template v-else>
                <template v-if="scope.row.thumb_media_id">
                  <video style="width: 20.0rem; height: 11.2rem" v-for="(item, index) in scope.row.media_id" :src="`${item}`"
                    :key="index" controls="controls"></video>
                </template>
                <template v-else>
                  <span v-if="!scope.row.link_url">
                    <el-image style="
                          width: 6.0rem;
                          height: 6.0rem;
                          margin-left: 1.0rem;
                          margin-top: 1.0rem;
                        " v-for="(item, index) in scope.row.media_id" :src="`${item}`"
                      :preview-src-list="scope.row.media_id" :key="index" fit="fill"></el-image>
                  </span>
                </template>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="location_name" label="位置" style="width:10%"> </el-table-column>
          <el-table-column prop="create_time" label="创建时间" style="width:10%">
          </el-table-column>
          <el-table-column prop="commonData" label="评论" style="width:10%" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="likeData" label="点赞" style="width:10%" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="create_type_name" label="来源" style="width:10%" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="visible_type_name" label="可见范围" show-overflow-tooltip style="width:10%">
          </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" :page-sizes="[10, 20, 50, 100]"
          @pagination="getData" />
      </div>
    </div>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "historyFriends",
  components: {
    Pagination,
    rightPeople
  },
  data() {
    return {
      checkbox: false,
      person: {
        name: "",
        userid: "",
      },
      tableData: [],
      module: "",
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      time: [],
      q: "",
      loading: false,
      updateLoading: false,
      create_type: "",
      options: [
        {
          label: "个人发表",
          value: 1,
        },
        {
          label: "企业发表",
          value: 0,
        },
      ],
      pickerOptions: {
        disabledDate: (date) => {
          const time = date.getTime();
          return (
            time > Date.now() - 3600 * 1000 * 24 * 1 &&
            time > Date.now() - 3600 * 1000 * 24 * 30
          );
        },
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },

  computed: {},
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getData();
  },

  methods: {
    async getRenew() {
      this.updateLoading = true;
      // 拉取更新历史朋友圈数据
      const { data: res } = await this.axios({
        url: "/crm/Dimission/getMomentList",
        method: "POST",
        data: qs.stringify({
          phone: this.tooken.phone,
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
        }),
      });
      this.updateLoading = false;
      this.tableData = [];
      this.getData();
    },
    async getData() {
      let start_time = "";
      let end_time = "";
      if (this.time !== null && this.time.length) {
        start_time = parseInt(this.time[0].getTime() / 1000);
        end_time = parseInt(this.time[1].getTime() / 1000);
      }

      const params = {
        phone: this.tooken.phone,
        usertoken: this.tooken.usertoken,
        account_id: this.tooken.account_id,
        page: this.listQuery.page,
        number_page: this.listQuery.limit,
        create_type: this.create_type,
        content: this.q,
        userid: this.person.userid,
        start_time,
        end_time,
      };
      this.loading = true;
      const { data: res } = await this.axios({
        url: "/crm/Dimission/getCrmCircleWx",
        method: "POST",
        data: qs.stringify(params),
      });

      if (res.code == 1) {
        this.total = res.count;
        this.tableData = res.data.data;
      }
      this.loading = false;
    },
    onSelectPerson() {
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      this.person = person;
      this.getData();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    clearD() {
      if (this.person.name == "") {
        this.person.userid = "";
      }
      this.getData();
    },
  },
};
</script>
<style scoped>
.nav-l {
  display: flex;
}

.link-container {
  background: rgb(236, 236, 236);
  padding: .6rem;
  overflow: hidden;
}

.el-link {
  display: inline;
}
</style>
